import React from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { FormattedHTMLMessage, FormattedMessage } from 'sb-react-intl'
import { useCallback, useMemo } from 'sb-hooks'
import useGlobals from 'sb-hooks/useGlobals'
import { useConnect } from 'sb-redux-hook'
import { constants, date, getMainPageLink } from 'common/helpers'

import Modal from 'components/modal/Modal/Modal'
import { Box } from 'components/_new/layout'
import Button from 'components/buttons/Button/Button'
import Link from 'components/_new/typography/Link/Link'

import messages from './messages'


const PauseOneMonthSuccessModal = (props) => {
  const { name } = props

  const { mainPageLink, nextBillingRawDate } = useConnect({
    mainPageLink: (state) => getMainPageLink({ state }),
    nextBillingRawDate: 'models.subscription.nextBillingDate',
  })

  const { redirect } = useGlobals(({ redirect }) => ({ redirect }))

  const handleClose = useCallback(() => {
    actions.models.modals.close(name)
  }, [ name ])

  //
  const handleOk = useCallback(() => {
    handleClose()
    redirect(mainPageLink)
  }, [ handleClose, redirect, mainPageLink ])

  // Unskip user
  const handleReactivate = useCallback(() => {
    actions.models.ui.showRequestLoader()

    actions.models.subscription.unskip('pause one month subscription modal')
      .finally(() => {
        actions.models.ui.hideRequestLoader()
      })
      .then(() => {
        handleClose()
      }, () => {})
  }, [ handleClose ])

  const nextBillingDate = useMemo(() => (
    date.formatDate(nextBillingRawDate, 'D MMM YYYY')
  ), [ nextBillingRawDate ])

  return (
    <Modal name={name} title={messages.title}>
      <FormattedHTMLMessage tag="div" {...messages.text} values={{ nextBillingDate }} />
      <Box mt={24}>
        <Button
          brand
          title={messages.okButton}
          onClick={handleOk}
        />
      </Box>
      <Box mt={36}>
        <FormattedMessage {...messages.didNotMean} tag="div" />
        <Link
          uppercase
          message={messages.reactivateButton}
          onClick={handleReactivate}
        />
      </Box>
    </Modal>
  )
}

PauseOneMonthSuccessModal.propTypes = {
  name: PropTypes.string.isRequired,
}

PauseOneMonthSuccessModal.defaultProps = {
  name: constants.modals.pauseSubscription.PauseOneMonthSuccess,
}


export default PauseOneMonthSuccessModal
